import ApplyParagraphAnnotations from "@elements/ArticleParagraph/ApplyParagraphAnnotations";
import Heading from "@elements/Typography/Heading";
import { ProcessedSubHead } from "@typings/Opensearch";

type SubHeadProps = {
  element: ProcessedSubHead;
};

export default function SubHead({ element }: SubHeadProps) {
  return (
    <Heading
      className="font-normal text-md text-red-100"
      Element={element.headingTag}
    >
      {ApplyParagraphAnnotations(element.subhead, element.annotations)}
    </Heading>
  );
}
